export default [
  {
    label: "人群",
    prop: "age",
    component: "el-input",
    disabled: true,
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [],
    fixed: "left",
  },
  {
    label: "热量（kcal/d）",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [],
    tableColumn: [
      {
        label: "男",
        tableForm: [],
        children: [
          {
            label: "身体活动水平（轻）",
            prop: "hotMan1",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（中）",
            prop: "hotMan2",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（重）",
            prop: "hotMan3",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
        ]
      },
      {
        label: "女",
        tableForm: [],
        children: [
          {
            label: "身体活动水平（轻）",
            prop: "hotWoman1",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（中）",
            prop: "hotWoman2",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（重）",
            prop: "hotWoman3",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
        ]
      },
    ]
  },
  {
    label: "能量（KJ/d）",
    prop: "name",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [],
    tableColumn: [
      {
        label: "男",
        tableForm: [],
        children: [
          {
            label: "身体活动水平（轻）",
            prop: "energyMan1",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（中）",
            prop: "energyMan2",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（重）",
            prop: "energyMan3",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
        ]
      },
      {
        label: "女",
        tableForm: [],
        children: [
          {
            label: "身体活动水平（轻）",
            prop: "energyWoman1",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（中）",
            prop: "energyWoman2",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
          {
            label: "身体活动水平（重）",
            prop: "energyWoman3",
            component: "el-input",
            rules: [{ required: true, message: "请输入", trigger: "blur" }],
            slot: "",
          },
        ]
      },
    ]
  },
  {
    label: "蛋白质（DRIs）",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "proteinMan",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "proteinWoman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "总碳水化合物（g/d)",
    prop: "totalCarbonWater",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "总脂肪（%E）",
    prop: "totalFat",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "膳食纤维(g/d)",
    prop: "mealsFiber",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "维生素ARNI",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "vitaminMan",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "vitaminWoman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "维生素B1 RNI",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "vitaminB1Man",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "vitaminB1Woman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "维生素B2 RNI",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "vitaminB2Man",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "vitaminB2Woman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "维生素C",
    prop: "vitaminC",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "维生素E",
    prop: "vitaminE",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "钙",
    prop: "calcium",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "磷",
    prop: "phosphorus",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "钾",
    prop: "potassium",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "钠",
    prop: "sodium",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "镁",
    prop: "magnesium",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "铁RNI",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "ironMan",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "ironWoman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "锌",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "zincMan",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "zincWoman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
  {
    label: "硒",
    prop: "selenium",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "铜",
    prop: "copper",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "锰",
    prop: "manganese",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: []
  },
  {
    label: "烟酸 RNI",
    prop: "",
    component: "el-input",
    rules: [{ required: true, message: "请输入人群", trigger: "blur" }],
    slot: "",
    children: [
      {
        label: "男",
        prop: "niacinMan",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      },
      {
        label: "女",
        prop: "niacinWoman",
        component: "el-input",
        rules: [{ required: true, message: "请输入", trigger: "blur" }],
        slot: "",
        children: []
      }
    ]
  },
]


// 字段映射表
export const fieldMap = {
  "age": "age",
  "热量（kcal）_man_lithe": "hotMan1",
  "热量（kcal）_man_middle": "hotMan2",
  "热量（kcal）_man_heavy": "hotMan3",
  "热量（kcal）_woman_lithe": "hotWoman1",
  "热量（kcal）_woman_middle": "hotWoman2",
  "热量（kcal）_woman_heavy": "hotWoman3",
  "能量（KJ）_man_lithe": "energyMan1",
  "能量（KJ）_man_middle": "energyMan2",
  "能量（KJ）_man_heavy": "energyMan3",
  "能量（KJ）_woman_lithe": "energyWoman1",
  "能量（KJ）_woman_middle": "energyWoman2",
  "能量（KJ）_woman_heavy": "energyWoman3",
  "蛋白质（g）_man": "proteinMan",
  "蛋白质（g）_woman": "proteinWoman",
  "碳水化合物（g）": "totalCarbonWater",
  "脂肪（g）": "totalFat",
  "膳食纤维（g）": "mealsFiber",
  "维生素A（μg）_man": "vitaminMan",
  "维生素A（μg）_woman": "vitaminWoman",
  "维生素B1（硫胺素）（mg）_man": "vitaminB1Man",
  "维生素B1（硫胺素）（mg）_woman": "vitaminB1Woman",
  "维生素B2（核黄素）（mg）_man": "vitaminB2Man",
  "维生素B2（核黄素）（mg）_woman": "vitaminB2Woman",
  "维生素C（mg）": "vitaminC",
  "维生素E（mg）": "vitaminE",
  "钙（mg）": "calcium",
  "磷（mg）": "phosphorus",
  "钾（mg）": "potassium",
  "钠（mg）": "sodium",
  "镁（mg）": "magnesium",
  "铁（mg）_man": "ironMan",
  "铁（mg）_woman": "ironWoman",
  "锌（mg）_man": "zincMan",
  "锌（mg）_woman": "zincWoman",
  "硒（μg）": "selenium",
  "铜（mg）": "copper",
  "锰（mg）": "manganese",
  "烟酸（mg）_man": "niacinMan",
  "烟酸（mg）_woman": "niacinWoman",
}

// 格式化获取字段
export const formatField = (item) => {
  const {elementName, sex, activityLevel} = item;
  const arr = [elementName, sex, activityLevel].filter(item => item);
  return arr.join("_");
}
